import { createModalContext, useModalState } from '@/common/app/modal'
import { MasterType } from '@/common/model/master/w2Master'
import { ChildProps } from '@/common/util/props'

import CsvUploadModal from '@/components/container/modal/csv/CsvUploadModal'

export interface CsvUploadModalState {
  siteId: number
  masterType: MasterType
  onClose: () => void
}

const defaultValue = {
  siteId: 0,
  masterType: MasterType.ORDERS,
  onClose: () => {}
}

export const CsvUploadModalContext = createModalContext<CsvUploadModalState>(defaultValue)

const CsvUploadModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<CsvUploadModalState>(defaultValue)
  return (
    <CsvUploadModalContext.Provider value={state}>
      {children}
      <CsvUploadModal />
    </CsvUploadModalContext.Provider>
  )
}

export default CsvUploadModalProvider
